export default {
  enabledLayers: (state) => state.enabledLayers,
  mapLayersCache: (state) => state.mapLayersCache,
  enabledZoneLayers: (state) => state.enabledZoneLayers,
  layerTypes: (state) => state.layerTypes,
  userLayers: (state) => state.userLayers,
  zoneLayers: (state) => state.zoneLayers,
  createMode: (state) => state.createMode,
  zoneEditing: (state) => state.zoneEditing,
  zoneSelectedId: (state) => state.zoneSelectedId,
  zoneStats: (state) => state.zoneStats,
  zonesToAdd: (state) => state.zonesToAdd,
  zonesToRemove: (state) => state.zonesToRemove,
  mapZones: (state) => state.mapZones,
  activatingLayer: (state) => state.activatingLayer,
  selectedPeriod: (state) => state.selectedPeriod,
  networkGraph: (state) => state.networkGraph
};



// WEBPACK FOOTER //
// ./src/store/workplace/getters.js